import { render, staticRenderFns } from "./bzscbb.vue?vue&type=template&id=755fdd66&scoped=true&"
import script from "./bzscbb.vue?vue&type=script&lang=js&"
export * from "./bzscbb.vue?vue&type=script&lang=js&"
import style0 from "./bzscbb.vue?vue&type=style&index=0&id=755fdd66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755fdd66",
  null
  
)

export default component.exports